'use client';
import Button from '@/components/platform/Button';
import * as Sentry from '@sentry/react';
import { useEffect, useState } from 'react';

export default function GlobalError({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  const [eventId, setEventId] = useState<string | null>(null);

  useEffect(() => {
    Sentry.init({
      dsn: 'https://2b5c477840445ec4f749aad5f0eb6fbb@o4509329498570752.ingest.us.sentry.io/4509329499422720',
      dataCollection: { userInfo: true },
      ignoreErrors: ['Non-Error promise rejection captured'],
      release: process.env.SENTRY_RELEASE,
    });

    const eid = Sentry.captureException(error);
    setEventId(eid);
  }, []);

  return (
    <html>
      <body className="w-full h-full">
        <div className="h-full flex flex-col items-center justify-center">
          <h2 className="font-bold">Something went wrong</h2>
          <p>Please try again later.</p>

          {eventId && <span className="font-mono">Error ID: {eventId}</span>}
        </div>
        <Button size="small" className="mt-2" onClick={() => reset()}>
          Try again
        </Button>
      </body>
    </html>
  );
}
